module.exports = __webpack_public_path__ + "static/media/bg_09.339603c6.png";